import React, { ComponentProps, ReactNode } from 'react';
import { OptionalElement } from '../optional-element';
import { Modal, ModalProps } from './modal';

export type StandardModalProps = {
  heading: ReactNode | ReactNode[];
  headingColor?: ComponentProps<typeof Modal.Heading>['color'];
  subheading?: ReactNode | ReactNode[];
  icon?: ReactNode | ReactNode[];
  image?: ReactNode | ReactNode[];
  footer?: ReactNode | ReactNode[];
} & ModalProps;

export const StandardModal = ({
  heading,
  headingColor,
  subheading,
  icon,
  image,
  footer,
  isOpen,
  onCloseModal,
  onNavigateBack,
  children,
  fitContent = false,
}: StandardModalProps) => (
  <Modal
    isOpen={isOpen}
    onCloseModal={onCloseModal}
    onNavigateBack={onNavigateBack}
    fitContent={fitContent}
  >
    <Modal.Body>
      <OptionalElement show={image !== undefined}>
        <Modal.Image>{image}</Modal.Image>
      </OptionalElement>
      <OptionalElement show={icon !== undefined}>
        <Modal.IconCircle>{icon}</Modal.IconCircle>
      </OptionalElement>
      <Modal.HeadingContainer>
        <Modal.Heading color={headingColor}>{heading}</Modal.Heading>
        <OptionalElement show={subheading !== undefined}>
          <Modal.Subheading>{subheading}</Modal.Subheading>
        </OptionalElement>
      </Modal.HeadingContainer>
      {children}
    </Modal.Body>
    <OptionalElement show={footer !== undefined}>
      <Modal.Footer>{footer}</Modal.Footer>
    </OptionalElement>
  </Modal>
);
